import React, { useEffect, useState, useContext } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import LogOut from './LogOut';
import GlobalContext from './GlobalContext';

function MainNav() {
    const [username, setUsername] = useState(null);
    const { globalData } = useContext(GlobalContext);

    const isAdmin = globalData.role === 'admin';

    useEffect(() => {
        const localStorageName = localStorage.getItem("navBarUsername");
        if (localStorageName) {
            setUsername(localStorageName);
        }
    }, []);

    return (
        <Navbar expand="lg" className="bg-body-secondary">
            <Container>
                <Navbar.Brand href="/">
                    <img
                        src="/static/images/logo_qualy.png"
                        height="50"
                        className="d-inline-block align-top"
                        alt="Logo"
                    />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        {isAdmin && (
                            <NavDropdown title="Gerenciamento" id="basic-nav-dropdown">
                                <NavDropdown.Item href="/gerenciamento/usuarios">Usuários</NavDropdown.Item>
                                <NavDropdown.Divider />
                                {/* <NavDropdown.Item href="/gerenciamento/presenca">Presença</NavDropdown.Item> */}
                                <NavDropdown.Item href="/gerenciamento/alunos">Alunos</NavDropdown.Item>
                                <NavDropdown.Item href="/gerenciamento/empresas">Empresas</NavDropdown.Item>
                            </NavDropdown>
                        )}
                        {isAdmin && (
                            <NavDropdown title="Manutenção" id="basic-nav-dropdown">
                                <NavDropdown.Item href="/manutencao/usuarios">Usuários</NavDropdown.Item>
                            </NavDropdown>
                        )}
                        <Nav.Link href="/relatorios/presencas">Relatório</Nav.Link>
                        <Nav.Link href="/dashboard">Dashboard</Nav.Link>
                        <Nav.Link href="/files">Arquivos</Nav.Link>
                        {isAdmin && <Nav.Link href="/configuracoes">Configurações</Nav.Link>}

                    </Nav>
                    <Nav className='ms-auto'>
                        <Nav.Item className='d-flex align-items-center me-5'>
                            <span className='fw-bold'>
                                Olá, {username}
                            </span>
                        </Nav.Item>
                        <Nav.Link><LogOut icon /></Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default MainNav;
